import http from 'utils/http';

const sendEmailSuport = payload =>
  http.post('/settings/v1/settings/sendmailsupport', payload);

const unsubscribe = token => http.get(`/settings/v1/unsubscribe/${token}`);

const deleteAccount = () => http.delete('/user/v1/user/delete-account');

export default {
  sendEmailSuport,
  unsubscribe,
  deleteAccount,
};



// WEBPACK FOOTER //
// ./src/services/settingsService.js